const UA = navigator.userAgent.toLowerCase();
export default UA;
